/**
 * @fileoverview gRPC-Web generated client stub for proto.services
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.4.2
// 	protoc              v3.20.3
// source: proto/services/rbf_service.proto


/* eslint-disable */
// @ts-nocheck


import * as grpcWeb from 'grpc-web';

import * as google_protobuf_empty_pb from 'google-protobuf/google/protobuf/empty_pb';
import * as proto_services_rbf_service_pb from '../../proto/services/rbf_service_pb';


export class RBFServiceClient {
  client_: grpcWeb.AbstractClientBase;
  hostname_: string;
  credentials_: null | { [index: string]: string; };
  options_: null | { [index: string]: any; };

  constructor (hostname: string,
               credentials?: null | { [index: string]: string; },
               options?: null | { [index: string]: any; }) {
    if (!options) options = {};
    if (!credentials) credentials = {};
    options['format'] = 'text';

    this.client_ = new grpcWeb.GrpcWebClientBase(options);
    this.hostname_ = hostname.replace(/\/+$/, '');
    this.credentials_ = credentials;
    this.options_ = options;
  }

  methodDescriptorUploadData = new grpcWeb.MethodDescriptor(
    '/proto.services.RBFService/UploadData',
    grpcWeb.MethodType.UNARY,
    proto_services_rbf_service_pb.UploadDataRequest,
    proto_services_rbf_service_pb.UploadDataResponse,
    (request: proto_services_rbf_service_pb.UploadDataRequest) => {
      return request.serializeBinary();
    },
    proto_services_rbf_service_pb.UploadDataResponse.deserializeBinary
  );

  uploadData(
    request: proto_services_rbf_service_pb.UploadDataRequest,
    metadata: grpcWeb.Metadata | null): Promise<proto_services_rbf_service_pb.UploadDataResponse>;

  uploadData(
    request: proto_services_rbf_service_pb.UploadDataRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: proto_services_rbf_service_pb.UploadDataResponse) => void): grpcWeb.ClientReadableStream<proto_services_rbf_service_pb.UploadDataResponse>;

  uploadData(
    request: proto_services_rbf_service_pb.UploadDataRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: proto_services_rbf_service_pb.UploadDataResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/proto.services.RBFService/UploadData',
        request,
        metadata || {},
        this.methodDescriptorUploadData,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/proto.services.RBFService/UploadData',
    request,
    metadata || {},
    this.methodDescriptorUploadData);
  }

  methodDescriptorBuildData = new grpcWeb.MethodDescriptor(
    '/proto.services.RBFService/BuildData',
    grpcWeb.MethodType.UNARY,
    proto_services_rbf_service_pb.BuildDataRequest,
    proto_services_rbf_service_pb.BuildDataResponse,
    (request: proto_services_rbf_service_pb.BuildDataRequest) => {
      return request.serializeBinary();
    },
    proto_services_rbf_service_pb.BuildDataResponse.deserializeBinary
  );

  buildData(
    request: proto_services_rbf_service_pb.BuildDataRequest,
    metadata: grpcWeb.Metadata | null): Promise<proto_services_rbf_service_pb.BuildDataResponse>;

  buildData(
    request: proto_services_rbf_service_pb.BuildDataRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: proto_services_rbf_service_pb.BuildDataResponse) => void): grpcWeb.ClientReadableStream<proto_services_rbf_service_pb.BuildDataResponse>;

  buildData(
    request: proto_services_rbf_service_pb.BuildDataRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: proto_services_rbf_service_pb.BuildDataResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/proto.services.RBFService/BuildData',
        request,
        metadata || {},
        this.methodDescriptorBuildData,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/proto.services.RBFService/BuildData',
    request,
    metadata || {},
    this.methodDescriptorBuildData);
  }

  methodDescriptorSubmitTrial = new grpcWeb.MethodDescriptor(
    '/proto.services.RBFService/SubmitTrial',
    grpcWeb.MethodType.UNARY,
    proto_services_rbf_service_pb.SubmitTrialRequest,
    proto_services_rbf_service_pb.SubmitTrialResponse,
    (request: proto_services_rbf_service_pb.SubmitTrialRequest) => {
      return request.serializeBinary();
    },
    proto_services_rbf_service_pb.SubmitTrialResponse.deserializeBinary
  );

  submitTrial(
    request: proto_services_rbf_service_pb.SubmitTrialRequest,
    metadata: grpcWeb.Metadata | null): Promise<proto_services_rbf_service_pb.SubmitTrialResponse>;

  submitTrial(
    request: proto_services_rbf_service_pb.SubmitTrialRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: proto_services_rbf_service_pb.SubmitTrialResponse) => void): grpcWeb.ClientReadableStream<proto_services_rbf_service_pb.SubmitTrialResponse>;

  submitTrial(
    request: proto_services_rbf_service_pb.SubmitTrialRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: proto_services_rbf_service_pb.SubmitTrialResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/proto.services.RBFService/SubmitTrial',
        request,
        metadata || {},
        this.methodDescriptorSubmitTrial,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/proto.services.RBFService/SubmitTrial',
    request,
    metadata || {},
    this.methodDescriptorSubmitTrial);
  }

  methodDescriptorCancelTrial = new grpcWeb.MethodDescriptor(
    '/proto.services.RBFService/CancelTrial',
    grpcWeb.MethodType.UNARY,
    proto_services_rbf_service_pb.CancelTrialRequest,
    google_protobuf_empty_pb.Empty,
    (request: proto_services_rbf_service_pb.CancelTrialRequest) => {
      return request.serializeBinary();
    },
    google_protobuf_empty_pb.Empty.deserializeBinary
  );

  cancelTrial(
    request: proto_services_rbf_service_pb.CancelTrialRequest,
    metadata: grpcWeb.Metadata | null): Promise<google_protobuf_empty_pb.Empty>;

  cancelTrial(
    request: proto_services_rbf_service_pb.CancelTrialRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: google_protobuf_empty_pb.Empty) => void): grpcWeb.ClientReadableStream<google_protobuf_empty_pb.Empty>;

  cancelTrial(
    request: proto_services_rbf_service_pb.CancelTrialRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: google_protobuf_empty_pb.Empty) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/proto.services.RBFService/CancelTrial',
        request,
        metadata || {},
        this.methodDescriptorCancelTrial,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/proto.services.RBFService/CancelTrial',
    request,
    metadata || {},
    this.methodDescriptorCancelTrial);
  }

  methodDescriptorCreateTrialSheet = new grpcWeb.MethodDescriptor(
    '/proto.services.RBFService/CreateTrialSheet',
    grpcWeb.MethodType.UNARY,
    proto_services_rbf_service_pb.CreateTrialSheetRequest,
    proto_services_rbf_service_pb.CreateTrialSheetResponse,
    (request: proto_services_rbf_service_pb.CreateTrialSheetRequest) => {
      return request.serializeBinary();
    },
    proto_services_rbf_service_pb.CreateTrialSheetResponse.deserializeBinary
  );

  createTrialSheet(
    request: proto_services_rbf_service_pb.CreateTrialSheetRequest,
    metadata: grpcWeb.Metadata | null): Promise<proto_services_rbf_service_pb.CreateTrialSheetResponse>;

  createTrialSheet(
    request: proto_services_rbf_service_pb.CreateTrialSheetRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: proto_services_rbf_service_pb.CreateTrialSheetResponse) => void): grpcWeb.ClientReadableStream<proto_services_rbf_service_pb.CreateTrialSheetResponse>;

  createTrialSheet(
    request: proto_services_rbf_service_pb.CreateTrialSheetRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: proto_services_rbf_service_pb.CreateTrialSheetResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/proto.services.RBFService/CreateTrialSheet',
        request,
        metadata || {},
        this.methodDescriptorCreateTrialSheet,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/proto.services.RBFService/CreateTrialSheet',
    request,
    metadata || {},
    this.methodDescriptorCreateTrialSheet);
  }

  methodDescriptorUpdateTrialSheet = new grpcWeb.MethodDescriptor(
    '/proto.services.RBFService/UpdateTrialSheet',
    grpcWeb.MethodType.UNARY,
    proto_services_rbf_service_pb.UpdateTrialSheetRequest,
    google_protobuf_empty_pb.Empty,
    (request: proto_services_rbf_service_pb.UpdateTrialSheetRequest) => {
      return request.serializeBinary();
    },
    google_protobuf_empty_pb.Empty.deserializeBinary
  );

  updateTrialSheet(
    request: proto_services_rbf_service_pb.UpdateTrialSheetRequest,
    metadata: grpcWeb.Metadata | null): Promise<google_protobuf_empty_pb.Empty>;

  updateTrialSheet(
    request: proto_services_rbf_service_pb.UpdateTrialSheetRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: google_protobuf_empty_pb.Empty) => void): grpcWeb.ClientReadableStream<google_protobuf_empty_pb.Empty>;

  updateTrialSheet(
    request: proto_services_rbf_service_pb.UpdateTrialSheetRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: google_protobuf_empty_pb.Empty) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/proto.services.RBFService/UpdateTrialSheet',
        request,
        metadata || {},
        this.methodDescriptorUpdateTrialSheet,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/proto.services.RBFService/UpdateTrialSheet',
    request,
    metadata || {},
    this.methodDescriptorUpdateTrialSheet);
  }

  methodDescriptorUpdateAnnotation = new grpcWeb.MethodDescriptor(
    '/proto.services.RBFService/UpdateAnnotation',
    grpcWeb.MethodType.UNARY,
    proto_services_rbf_service_pb.UpdateAnnotationRequest,
    google_protobuf_empty_pb.Empty,
    (request: proto_services_rbf_service_pb.UpdateAnnotationRequest) => {
      return request.serializeBinary();
    },
    google_protobuf_empty_pb.Empty.deserializeBinary
  );

  updateAnnotation(
    request: proto_services_rbf_service_pb.UpdateAnnotationRequest,
    metadata: grpcWeb.Metadata | null): Promise<google_protobuf_empty_pb.Empty>;

  updateAnnotation(
    request: proto_services_rbf_service_pb.UpdateAnnotationRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: google_protobuf_empty_pb.Empty) => void): grpcWeb.ClientReadableStream<google_protobuf_empty_pb.Empty>;

  updateAnnotation(
    request: proto_services_rbf_service_pb.UpdateAnnotationRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: google_protobuf_empty_pb.Empty) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/proto.services.RBFService/UpdateAnnotation',
        request,
        metadata || {},
        this.methodDescriptorUpdateAnnotation,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/proto.services.RBFService/UpdateAnnotation',
    request,
    metadata || {},
    this.methodDescriptorUpdateAnnotation);
  }

  methodDescriptorMarkLongLive = new grpcWeb.MethodDescriptor(
    '/proto.services.RBFService/MarkLongLive',
    grpcWeb.MethodType.UNARY,
    proto_services_rbf_service_pb.MarkLongLiveRequest,
    google_protobuf_empty_pb.Empty,
    (request: proto_services_rbf_service_pb.MarkLongLiveRequest) => {
      return request.serializeBinary();
    },
    google_protobuf_empty_pb.Empty.deserializeBinary
  );

  markLongLive(
    request: proto_services_rbf_service_pb.MarkLongLiveRequest,
    metadata: grpcWeb.Metadata | null): Promise<google_protobuf_empty_pb.Empty>;

  markLongLive(
    request: proto_services_rbf_service_pb.MarkLongLiveRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: google_protobuf_empty_pb.Empty) => void): grpcWeb.ClientReadableStream<google_protobuf_empty_pb.Empty>;

  markLongLive(
    request: proto_services_rbf_service_pb.MarkLongLiveRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: google_protobuf_empty_pb.Empty) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/proto.services.RBFService/MarkLongLive',
        request,
        metadata || {},
        this.methodDescriptorMarkLongLive,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/proto.services.RBFService/MarkLongLive',
    request,
    metadata || {},
    this.methodDescriptorMarkLongLive);
  }

  methodDescriptorMarkPublish = new grpcWeb.MethodDescriptor(
    '/proto.services.RBFService/MarkPublish',
    grpcWeb.MethodType.UNARY,
    proto_services_rbf_service_pb.MarkPublishRequest,
    google_protobuf_empty_pb.Empty,
    (request: proto_services_rbf_service_pb.MarkPublishRequest) => {
      return request.serializeBinary();
    },
    google_protobuf_empty_pb.Empty.deserializeBinary
  );

  markPublish(
    request: proto_services_rbf_service_pb.MarkPublishRequest,
    metadata: grpcWeb.Metadata | null): Promise<google_protobuf_empty_pb.Empty>;

  markPublish(
    request: proto_services_rbf_service_pb.MarkPublishRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: google_protobuf_empty_pb.Empty) => void): grpcWeb.ClientReadableStream<google_protobuf_empty_pb.Empty>;

  markPublish(
    request: proto_services_rbf_service_pb.MarkPublishRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: google_protobuf_empty_pb.Empty) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/proto.services.RBFService/MarkPublish',
        request,
        metadata || {},
        this.methodDescriptorMarkPublish,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/proto.services.RBFService/MarkPublish',
    request,
    metadata || {},
    this.methodDescriptorMarkPublish);
  }

  methodDescriptorQueryStatus = new grpcWeb.MethodDescriptor(
    '/proto.services.RBFService/QueryStatus',
    grpcWeb.MethodType.UNARY,
    proto_services_rbf_service_pb.QueryStatusRequest,
    proto_services_rbf_service_pb.QueryStatusResponse,
    (request: proto_services_rbf_service_pb.QueryStatusRequest) => {
      return request.serializeBinary();
    },
    proto_services_rbf_service_pb.QueryStatusResponse.deserializeBinary
  );

  queryStatus(
    request: proto_services_rbf_service_pb.QueryStatusRequest,
    metadata: grpcWeb.Metadata | null): Promise<proto_services_rbf_service_pb.QueryStatusResponse>;

  queryStatus(
    request: proto_services_rbf_service_pb.QueryStatusRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: proto_services_rbf_service_pb.QueryStatusResponse) => void): grpcWeb.ClientReadableStream<proto_services_rbf_service_pb.QueryStatusResponse>;

  queryStatus(
    request: proto_services_rbf_service_pb.QueryStatusRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: proto_services_rbf_service_pb.QueryStatusResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/proto.services.RBFService/QueryStatus',
        request,
        metadata || {},
        this.methodDescriptorQueryStatus,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/proto.services.RBFService/QueryStatus',
    request,
    metadata || {},
    this.methodDescriptorQueryStatus);
  }

  methodDescriptorQueryMetricsBySheet = new grpcWeb.MethodDescriptor(
    '/proto.services.RBFService/QueryMetricsBySheet',
    grpcWeb.MethodType.UNARY,
    proto_services_rbf_service_pb.QueryMetricsRequest,
    proto_services_rbf_service_pb.QueryMetricsResponse,
    (request: proto_services_rbf_service_pb.QueryMetricsRequest) => {
      return request.serializeBinary();
    },
    proto_services_rbf_service_pb.QueryMetricsResponse.deserializeBinary
  );

  queryMetricsBySheet(
    request: proto_services_rbf_service_pb.QueryMetricsRequest,
    metadata: grpcWeb.Metadata | null): Promise<proto_services_rbf_service_pb.QueryMetricsResponse>;

  queryMetricsBySheet(
    request: proto_services_rbf_service_pb.QueryMetricsRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: proto_services_rbf_service_pb.QueryMetricsResponse) => void): grpcWeb.ClientReadableStream<proto_services_rbf_service_pb.QueryMetricsResponse>;

  queryMetricsBySheet(
    request: proto_services_rbf_service_pb.QueryMetricsRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: proto_services_rbf_service_pb.QueryMetricsResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/proto.services.RBFService/QueryMetricsBySheet',
        request,
        metadata || {},
        this.methodDescriptorQueryMetricsBySheet,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/proto.services.RBFService/QueryMetricsBySheet',
    request,
    metadata || {},
    this.methodDescriptorQueryMetricsBySheet);
  }

  methodDescriptorQueryResourceType = new grpcWeb.MethodDescriptor(
    '/proto.services.RBFService/QueryResourceType',
    grpcWeb.MethodType.UNARY,
    proto_services_rbf_service_pb.QueryResourceTypeRequest,
    proto_services_rbf_service_pb.QueryResourceTypeResponse,
    (request: proto_services_rbf_service_pb.QueryResourceTypeRequest) => {
      return request.serializeBinary();
    },
    proto_services_rbf_service_pb.QueryResourceTypeResponse.deserializeBinary
  );

  queryResourceType(
    request: proto_services_rbf_service_pb.QueryResourceTypeRequest,
    metadata: grpcWeb.Metadata | null): Promise<proto_services_rbf_service_pb.QueryResourceTypeResponse>;

  queryResourceType(
    request: proto_services_rbf_service_pb.QueryResourceTypeRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: proto_services_rbf_service_pb.QueryResourceTypeResponse) => void): grpcWeb.ClientReadableStream<proto_services_rbf_service_pb.QueryResourceTypeResponse>;

  queryResourceType(
    request: proto_services_rbf_service_pb.QueryResourceTypeRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: proto_services_rbf_service_pb.QueryResourceTypeResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/proto.services.RBFService/QueryResourceType',
        request,
        metadata || {},
        this.methodDescriptorQueryResourceType,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/proto.services.RBFService/QueryResourceType',
    request,
    metadata || {},
    this.methodDescriptorQueryResourceType);
  }

  methodDescriptorQueryResourcesList = new grpcWeb.MethodDescriptor(
    '/proto.services.RBFService/QueryResourcesList',
    grpcWeb.MethodType.UNARY,
    proto_services_rbf_service_pb.QueryResourcesListRequest,
    proto_services_rbf_service_pb.QueryResourcesListResponse,
    (request: proto_services_rbf_service_pb.QueryResourcesListRequest) => {
      return request.serializeBinary();
    },
    proto_services_rbf_service_pb.QueryResourcesListResponse.deserializeBinary
  );

  queryResourcesList(
    request: proto_services_rbf_service_pb.QueryResourcesListRequest,
    metadata: grpcWeb.Metadata | null): Promise<proto_services_rbf_service_pb.QueryResourcesListResponse>;

  queryResourcesList(
    request: proto_services_rbf_service_pb.QueryResourcesListRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: proto_services_rbf_service_pb.QueryResourcesListResponse) => void): grpcWeb.ClientReadableStream<proto_services_rbf_service_pb.QueryResourcesListResponse>;

  queryResourcesList(
    request: proto_services_rbf_service_pb.QueryResourcesListRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: proto_services_rbf_service_pb.QueryResourcesListResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/proto.services.RBFService/QueryResourcesList',
        request,
        metadata || {},
        this.methodDescriptorQueryResourcesList,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/proto.services.RBFService/QueryResourcesList',
    request,
    metadata || {},
    this.methodDescriptorQueryResourcesList);
  }

  methodDescriptorAddTag = new grpcWeb.MethodDescriptor(
    '/proto.services.RBFService/AddTag',
    grpcWeb.MethodType.UNARY,
    proto_services_rbf_service_pb.AddTagRequest,
    google_protobuf_empty_pb.Empty,
    (request: proto_services_rbf_service_pb.AddTagRequest) => {
      return request.serializeBinary();
    },
    google_protobuf_empty_pb.Empty.deserializeBinary
  );

  addTag(
    request: proto_services_rbf_service_pb.AddTagRequest,
    metadata: grpcWeb.Metadata | null): Promise<google_protobuf_empty_pb.Empty>;

  addTag(
    request: proto_services_rbf_service_pb.AddTagRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: google_protobuf_empty_pb.Empty) => void): grpcWeb.ClientReadableStream<google_protobuf_empty_pb.Empty>;

  addTag(
    request: proto_services_rbf_service_pb.AddTagRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: google_protobuf_empty_pb.Empty) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/proto.services.RBFService/AddTag',
        request,
        metadata || {},
        this.methodDescriptorAddTag,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/proto.services.RBFService/AddTag',
    request,
    metadata || {},
    this.methodDescriptorAddTag);
  }

  methodDescriptorCancelTrialsBySheet = new grpcWeb.MethodDescriptor(
    '/proto.services.RBFService/CancelTrialsBySheet',
    grpcWeb.MethodType.UNARY,
    proto_services_rbf_service_pb.CancelTrialsBySheetRequest,
    proto_services_rbf_service_pb.CancelTrialsBySheetResponse,
    (request: proto_services_rbf_service_pb.CancelTrialsBySheetRequest) => {
      return request.serializeBinary();
    },
    proto_services_rbf_service_pb.CancelTrialsBySheetResponse.deserializeBinary
  );

  cancelTrialsBySheet(
    request: proto_services_rbf_service_pb.CancelTrialsBySheetRequest,
    metadata: grpcWeb.Metadata | null): Promise<proto_services_rbf_service_pb.CancelTrialsBySheetResponse>;

  cancelTrialsBySheet(
    request: proto_services_rbf_service_pb.CancelTrialsBySheetRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: proto_services_rbf_service_pb.CancelTrialsBySheetResponse) => void): grpcWeb.ClientReadableStream<proto_services_rbf_service_pb.CancelTrialsBySheetResponse>;

  cancelTrialsBySheet(
    request: proto_services_rbf_service_pb.CancelTrialsBySheetRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: proto_services_rbf_service_pb.CancelTrialsBySheetResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/proto.services.RBFService/CancelTrialsBySheet',
        request,
        metadata || {},
        this.methodDescriptorCancelTrialsBySheet,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/proto.services.RBFService/CancelTrialsBySheet',
    request,
    metadata || {},
    this.methodDescriptorCancelTrialsBySheet);
  }

}

